/* eslint-disable no-console,no-undef */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  StyledModal, CalendarWrapper, ConfirmVisitText,
} from '../PeopleHomeV2/ManageBuddies/styles';
import { HeadingBranding } from '../DeletePostPopup/styles.js';

import {ButtonWrapper} from '../HrisIntegration/style'
import {WarningDelete, RecognitionCloseIcon, DustbinIcon, RemoveUserIcon} from '../../utils/icons'
import { withTranslation } from 'react-i18next';

class LeavePopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSingleClick: false
    }
  }

  deleteDataHandle = () => {
    const { deleteData, deleteId } = this.props;
    this.setState({
      showSingleClick: true
    }, () => deleteData(deleteId))
  }

  leaveDataHandle = () => {
    const { leaveData, leaveId } = this.props;
    this.setState({
      showSingleClick: true
    }, () => leaveData(leaveId))
  }

  render() {
    const { 
      userName, 
      showConfirmPopup, 
      showHideLeavePopup, 
      showConfirmPopupDelete,
      showHideDeletePopup,
      showDelete, 
      showDeleteLibrary, 
      t 
    } = this.props;
    
    const { showSingleClick } = this.state;

    const isDeletePopup = showDelete || showDeleteLibrary;
    const showModal = isDeletePopup ? showConfirmPopupDelete : showConfirmPopup;

    return (
      <StyledModal show={showModal ? true : false} width={"400px"} paddingV='16px'>
        <HeadingBranding>
          <div className='warning'>
            {WarningDelete('#DA6C74')}
          </div>
          {isDeletePopup ? t("Delete Challenge") : t("Leave The Challenge")}
          <div className='close' onClick={isDeletePopup ? () => showHideDeletePopup() : () => showHideLeavePopup()}>
            {RecognitionCloseIcon('#F37A65')}
          </div>
        </HeadingBranding>
        <div style={{background:"#EFEFEF", height:"1px", width:"100%", marginTop:"20px"}}/>
        <CalendarWrapper padding="0">
          <ConfirmVisitText isTopData margin="20px 0px 20px 0px" display="block">
            <div className='text'>
              {isDeletePopup ? t("Are you sure you want to delete this challenge?") : t("Are you sure you want to Leave this Challenge?")}
            </div>
            <div className='danger'>
              {isDeletePopup ? (
                <>
                  This action cannot be undone, and all associated data will be permanently removed from the system.
                </>
              ) : (
                <>
                  Hey {userName}, If you leave this challenge in middle you won&apos;t get the points for this challenge.
                </>
              )}
            </div>
          </ConfirmVisitText>
          
          <ButtonWrapper>
            <div className='cancel' onClick={isDeletePopup ? () => showHideDeletePopup() : () => showHideLeavePopup()}>
              {isDeletePopup ? t("Keep Challenge") : t("No, I want to stay")}
            </div>
            <div className='create' onClick={showSingleClick ? null : (isDeletePopup ? () => this.deleteDataHandle() : () => this.leaveDataHandle())}>
              <div className='icon'>
                {isDeletePopup ? DustbinIcon() : RemoveUserIcon("#F8F8F8")}
              </div>
              {isDeletePopup ? t("Delete Permanently") : t("Yes, I Want Leave")}
            </div>
          </ButtonWrapper>
        </CalendarWrapper>
      </StyledModal>
    );
  }
}

LeavePopup.propTypes = {
  leaveId: PropTypes.number,
  showConfirmPopup: PropTypes.bool,
  showHideLeavePopup: PropTypes.func,
  leaveData: PropTypes.func,
  userName: PropTypes.string,
  deleteId: PropTypes.number,
  showConfirmPopupDelete: PropTypes.bool,
  showHideDeletePopup: PropTypes.func,
  deleteData: PropTypes.func,
  showDelete: PropTypes.bool,
  showDeleteLibrary: PropTypes.bool,
  t: PropTypes.func
};

export default withTranslation()(LeavePopup);